import type { AutobidCmsConfig } from '@autobid/strapi-integration/typescript/Config'

export function useCmsConfig() {
  return useRuntimeConfig().public.autobidCMS as AutobidCmsConfig
}
